import { createApi } from '@reduxjs/toolkit/query/react';
import { FileRawT, GuidT } from '@/types/common';
import { AddFileIF, GetFileIF } from '@/api/filesApi/types';
import { fetchRestApiQuery } from '@/helpers/api';

export const filesApi = createApi({
    reducerPath: 'filesApi',
    baseQuery: fetchRestApiQuery('/Files'),
    endpoints: (builder) => ({
        addFile: builder.mutation<GuidT, FormData>({
            query: (body) => ({
                url: '',
                method: 'POST',
                body,
            }),
            transformResponse(response: AddFileIF) {
                return response?.guid;
            },
        }),
        getFile: builder.mutation<FileRawT, GetFileIF>({
            query: ({ fileGuid, size = 'S' }) => ({
                url: `/${fileGuid}`,
                params: { size },
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: (file: Blob): string =>
                URL.createObjectURL(file),
        }),
        deleteFile: builder.mutation<GuidT, GuidT>({
            query: (fileId) => ({
                url: `/${fileId}`,
                method: 'DELETE',
            }),
        }),
    }),
});
